export type CountryType = {
  id: string;
  name: string;
  countryCode: string;
  ccn3: string;
  language: {
    [type: string]: string;
  };
};

export type InsuranceParameters = {
  modalsVisibility: {
    countries: boolean;
    dates: boolean;
    tourists: boolean;
  };
  selectedCountry: {
    name: {
      [type: string]: string;
    };
    id: string;
  };
  selectedTourists: Array<Tourist>;
  selectedDates: {
    startDate: any;
    endDate: any;
    key: string;
  };
  selectedInsurance?: {
    logo: string;
    name: string;
    sum: number;
  };
};

export type Tourist = {
  birthDate: string;
  name?: string;
  surname?: string;
  idnp?: string;
  passportNumber?: string;
  phoneNumber?: string;
  email?: string;
  fieldsCompleted: boolean;
  country?: string;
  city?: string;
};

export type Beneficiary = {
  first_name: string,
  last_name: string,
  date_of_birth: Date | string,
  country: string,
  city: string,
  address: string,
  passport_series_number: string,
  idnp: string,
  email: string,
  phone: string
};

export type SetInsuranceParameters = (params: InsuranceParameters) => void;
export type SetInsurance = (params: IInsurance) => void;

export type Company = {
  display_name: string;
  logo: string;
  name: string;
  offers: Array<Offers>;
  linkInsuranceRules: string;
  optionsNumber: string;
};

export type Offers = {
  sum: number;
  amount: { mdl: number; eur: number };
  covid: boolean;
  type: string;
};

export enum FormInsurance {
  Individual = 'individual',
  Group = 'group',
};

export type Details = {
  destination: string,
  destination_name?: string,
  beneficiary_in_md: boolean,
  one_trip: boolean,
  start_date: Date | string,
  end_date: Date | string,
  purpose: string,
  covid_cover: boolean,
  insurance_form: FormInsurance | string,   
  insurance_company: string,
  sum_mdl: number,
  sum_eur: number
};

export type Payer = {
  user_id: string,
  first_name: string,
  last_name: string,
  phone: string,
  email: string,
};

export interface IInsurance {
  insurance_type: string;
  details: Details;
  beneficiary: Beneficiary[];
  payer: Payer;
};

export type GlobalInsurance = {
  insurance: IInsurance,
  insuranceParameters: InsuranceParameters,
  setInsurance: SetInsurance,
  setInsuranceParameters: SetInsuranceParameters
};

export type DefaultTouristData = {
  name: string,
  surname: string, 
  passportNumber: string,  
  idnp: string, 
  phoneNumber: string,
  country: string,
  city: string,
  email?: string
};

export type UserTouristErrors = {
  name: boolean,
  surname: boolean, 
  passportNumber: boolean, 
  idnp: boolean, 
  phoneNumber: boolean,  
  city: boolean,
  email?: boolean,
}




